"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllCollateralCurrencyIds = void 0;
const operators_1 = require("rxjs/operators");
function getAllCollateralCurrencyIds(api) {
    return api.query.cdpEngine.collateralParams.keys().pipe((0, operators_1.map)((keys) => {
        return keys.map((item) => item.args[0]);
    }));
}
exports.getAllCollateralCurrencyIds = getAllCollateralCurrencyIds;
